import React, {Component} from 'react';
import Header from '../Header';
import {withRouter} from 'react-router-dom';
import styles from './ChallengeBadges.module.css';

export class ChallengeBadges extends Component {
  navigateToChallenge = (challengeId) => {
    this.props.history.push({
      pathname: `/challenges/${challengeId}`,
    });
  };

  render() {
    const {history} = this.props;
    const {badgesData} = this.props.location.state;

    return (
      <div>
        <Header
          title={'Challenge Badges'}
          onBack={() => {
            history.goBack();
          }}
        />
        <div className={[styles.contentContainer]}>
          {badgesData.map((badge, index) => {
            return (
              <div
                className={[styles.badgeContainer]}
                onClick={() => {
                  this.navigateToChallenge(badge.challenge_id);
                }}
                key={index}>
                <img
                  className={styles.badgeImage}
                  src={badge.image_url}
                  alt="badge"
                />
                <div className={[styles.dateContainer]}>
                  <p className={[styles.dateText]}>23-12-2023</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default withRouter(ChallengeBadges);
